var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"tc mationDialog"},[_c('div',{staticClass:"title"},[_vm._v("你还有简历未完善，赶快去完善吧！")]),_c('div',{},[_vm._v("完善后将会有更多的公司关注到你")])])
}]

export { render, staticRenderFns }